<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Category Store" subTitle="Forms" />

    <ListCategoryStore />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListCategoryStore from "@/components/Pages/Master/CategoryStore/ListCategoryStore.vue";

export default defineComponent({
  name: "ListCategoryStorePage",
  components: {
    PageTitle,
    ListCategoryStore,
  },
});
</script>
